module.exports = __webpack_public_path__ + "static/media/7.c2b87ffc.jpg";